module.exports = __webpack_public_path__ + "static/Logo_WUM-fe1dd187a597f645bd2b84f533aeb458.jpg";